import dayjs from 'utils/dayjs-timezone';
export const hasSearchChanged = (newState, oldState) => {
    // Location changes are not considered as the data available from the Search component only changes when the user makes a suggestion choice.
    // Selecting an autocomplete suggestion will trigger a search via trackSearchSuggestionSelected callback.
    if (newState.parkingType !== oldState.parkingType ||
        newState.parkingSubType !== oldState.parkingSubType) {
        return true;
    }
    if (newState.parkingSubType === 'hourly' &&
        !(dayjs(newState.startDate).isSame(dayjs(oldState.startDate)) &&
            dayjs(newState.endDate).isSame(dayjs(oldState.endDate)))) {
        return true;
    }
    if (newState.parkingSubType === 'event' &&
        !(dayjs(newState.startDate).isSame(dayjs(oldState.startDate)) &&
            dayjs(newState.endDate).isSame(dayjs(oldState.endDate)))) {
        return true;
    }
    if (newState.parkingSubType === 'monthly' &&
        !dayjs(newState.monthlyStartDate).isSame(dayjs(oldState.monthlyStartDate))) {
        return true;
    }
    if (newState.parkingSubType === 'power_booking' &&
        !(newState.dates.length === oldState.powerBookingDates.length &&
            newState.dates.every((date, index) => dayjs(date).isSame(dayjs(oldState.powerBookingDates[index]))) &&
            newState.startTime === oldState.powerBookingStartTime &&
            newState.endTime === oldState.powerBookingEndTime)) {
        return true;
    }
    return false;
};
